<div class="main-menu-container" [class.menu-open]="isMenuOpen()">
  <ul class="main-menu">
    @if(menuData().status === 'loading') {
      <li class="loading-item">Loading items...</li>
    } @else if (menuData().status === 'error') {
      <li class="error-item">Error loading menu items</li>
    } @else if (menuData().status === 'success' && menuData().data) {
      <div class="tab-menu-group">
        <app-tab-group [tabButtonGroup]="tabButtonGroup()" (selectedTab)="filterMenuItemsByCategory($event)"></app-tab-group>
      </div>
      <div class="search-container">
        <div class="search-content">
          <div class="search-icon">
            <i class="fa fa-search" aria-hidden="true"></i>
          </div>
          <input
            type="text"
            placeholder="Search by..."
            class="search-input"
            [(ngModel)]="modelSearchTerm"
            (ngModelChange)="onSearchTermChange($event)"
          />
        </div>
        <div class="collapse-content">
          <div class="divisor-dashed"></div>
          <img
            [src]="expandedMenuItems() ? '../../../../assets/images/icons/double-arrow-up.svg' : '../../../../assets/images/icons/double-arrow-down.svg'"
            (click)="toggleAllExpanded()"
          >
        </div>
      </div>
      @for (item of filteredMenuItems(); track item.title) {
        <ng-container
          *ngTemplateOutlet="menuItemTemplate; context: { item: item, currentLevel: 0 }"
        ></ng-container>
      }
    }
  </ul>
</div>

<div class="side-menu-backdrop" [class.menu-open]="isMenuOpen()" (click)="menuStateService.setMenuState(false)"></div>

<ng-template #menuItemTemplate let-item="item" let-currentLevel="currentLevel">
  @if (item.access) {
    <li [ngClass]="getItemClasses(item, currentLevel)">
      @if (item.link) {
        <a [routerLink]="item.link" routerLinkActive="active-link" (click)="menuStateService.setMenuState(false)">
          {{ item.title }}
          @if (!!(item.items && item.items.length > 0)) {
            <i
              [ngClass]="item.isExpanded ? 'fa fa-angle-up' : 'fa fa-angle-down'"
              aria-hidden="true"
            ></i>
          }
        </a>
      } @else {
        <span class="menu-title-wrapper" (click)="toggleExpand(item)">
          {{ item.title }}
          @if (!!(item.items && item.items.length > 0)) {
            <i
              [ngClass]="item.isExpanded ? 'fa fa-angle-up' : 'fa fa-angle-down'"
              aria-hidden="true"
            ></i>
          }
        </span>
      }

      @if (!!(item.items && item.items.length > 0) && item.isExpanded) {
        <ul class="sub-menu">
          @for (subItem of item.items; track subItem.title) {
            <ng-container
              *ngTemplateOutlet="menuItemTemplate; context: { item: subItem, currentLevel: currentLevel + 1 }"
            ></ng-container>
          }
        </ul>
      }
    </li>
  }
</ng-template>